import React from 'react';
import clsx from 'clsx';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

const StatCard = ({ title, amount, type, trend }) => {
    const isIncome = type === 'income';
    const isExpense = type === 'expense';

    return (
        <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200">
            <div className="flex justify-between items-start mb-3">
                <h3 className="text-gray-500 text-xs font-medium uppercase tracking-wide">{title}</h3>
                <div className={clsx(
                    "p-1.5 rounded-lg",
                    isIncome ? "bg-emerald-50 text-emerald-600" :
                        isExpense ? "bg-rose-50 text-rose-600" : "bg-blue-50 text-blue-600"
                )}>
                    {isIncome ? <ArrowUpRight size={16} /> :
                        isExpense ? <ArrowDownRight size={16} /> :
                            <span className="text-sm font-bold">₹</span>}
                </div>
            </div>
            <div className="flex items-baseline gap-2">
                <span className="text-2xl font-bold text-gray-900">
                    {amount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' })}
                </span>
            </div>
            {trend && (
                <p className={clsx("text-xs mt-2 font-medium", trend > 0 ? "text-emerald-600" : "text-rose-600")}>
                    {trend > 0 ? '+' : ''}{trend}% from last month
                </p>
            )}
        </div>
    );
};

export default StatCard;
